import { useTranslation } from "next-i18next";
import { Footer } from "../../../components/blog/footerBlog";
import ContactSectionForm from "../../../components/ContactSectionForm";
import { TopbarLanding } from "../../../components/LandingPage/topbar";
import DefaultDarkModeHOC from "../../../components/theme/DefaultDarkModeHOC";
import WhatsAppButton from "../../../components/WhatsAppButton";
import {
	getI18nPaths,
	getI18nProps,
} from "../../../lib/next-i18next/getStatic";
import { FaceLiftGlobalStyle } from "../../../styles/theme";
import { ProductMetadata } from "./product-metadata";
import AdvantagesSection from "./views/squad-ia-sections/Advantages";
import DevelopmentComparisonSection from "./views/squad-ia-sections/DevelopmentComparison";
import HeroSection from "./views/squad-ia-sections/HeroSection";
import { MethodologySection } from "./views/squad-ia-sections/Methodology";
import ResultsSection from "./views/squad-ia-sections/Results";

export default function SquadIAPage(data) {
	const { t } = useTranslation();

	return (
		<DefaultDarkModeHOC>
			<ProductMetadata
				translations={data.translations}
				slug="squad-ia"
				imagePath="/landings/assets/images/products/squad-ia/squad-ia-background.jpg"
			/>
			<TopbarLanding />
			<FaceLiftGlobalStyle />

			<main>
				<HeroSection />
				<AdvantagesSection />
				<MethodologySection />
				<ResultsSection />
				<DevelopmentComparisonSection />

				<ContactSectionForm
					title={t("products.squad-ia.contact.title")}
					description={t("products.squad-ia.contact.description")}
				/>
			</main>

			<WhatsAppButton />
			<Footer defaultTheme="dark" />
		</DefaultDarkModeHOC>
	);
}

export async function getStaticProps(ctx) {
	const locale = ctx.params?.locale || "pt";
	const i18nProps = await getI18nProps(ctx);
	const translations =
		i18nProps._nextI18Next.initialI18nStore[locale].translation;

	return {
		props: {
			...i18nProps,
			translations,
			product: {
				slug: "squad-ia",
				locale,
			},
		},
	};
}

export async function getStaticPaths() {
	const squadIAPathsWithLocale = getI18nPaths([{ slug: "squad-ia" }]);

	return {
		paths: squadIAPathsWithLocale,
		fallback: false,
	};
}
